var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-table"},[_c('div',{staticClass:"title"},[_c('h6',{staticStyle:{"margin-right":"16px"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("buttons")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }